import { SQLService } from '../../../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-moderator-menu',
  templateUrl: './moderator-menu.component.html',
  styleUrls: ['./moderator-menu.component.styl']
})
export class ModeratorMenuComponent implements OnInit {
  constructor(
    public sql: SQLService,
    public popover: PopoverController,
    private router: Router) {
  }
  list:string;
  @Input('enabled') enabled:boolean;
  dismissPopover(e) {
    if (this.popover) this.popover.dismiss(e);
  }
  delete() {
    this.dismissPopover('delete');
  }
  disable() {
    this.dismissPopover('disable');
  }
  enable() {
    this.dismissPopover('enable');
  }
  ngOnInit() {
  }
}